<template>

	<div v-if="name || title || image" :class="{'author_center' : isCenter}" class="author">
		<div :class="{'author_card_anchor' : hasAnchor}" class="author_card" @click="anchorGoto">
			<div v-if="image" :class="{'author_card_image_small' : isSmallCard}" class="author_card_image">
				<img :src="imgPath(image)"/>
			</div>
			<div class="author_card_content">
				<div class="author_card_content_name" v-html="name"></div>
				<div class="author_card_content_title" v-html="title"></div>
			</div>
		</div>
		<div v-if="quote" class="author_quote" v-html="quote">
		</div>
	</div>

</template>

<script>
import $ from "jquery";
import top from "jquery";
import ArticleSection from "./ArticleSection";

export default {
	name: "Author",
	components: {ArticleSection},
	props: ["image", "name", "title", "quote", "centered", "anchor", "smallCard"],
	data: function () {
		return {
			isCenter: false,
			hasAnchor: false,
			isSmallCard: false
		};
	},
	methods: {
		imgPath: function (image) {
			return require("../assets/img/" + image);
		},
		anchorGoto: function () {
			if (this.anchor) {
				this.$events.fire("page-unlockScroll");
				let hash = this.anchor;
				let target_anchor = $("#" + this.anchor);
				let offset_anchor = $(target_anchor).offset().top;

				$(".pageSelector .page").animate({
					scrollTop: offset_anchor
				}, 500, function () {
					////console.log(hash);
				});
			}

		}
	},
	mounted: function () {

		if (this.centered == "center") {
			this.isCenter = true;
		}

		if (this.anchor) {
			this.hasAnchor = true;
		}

		if (this.smallCard) {
			this.isSmallCard = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.author {

	&_card {
		display: flex;
		align-items: center;
		gap: $G-default;
		@include breakpoint(lt-sm) {
			flex-direction: column;
			align-items: flex-start;
		}

		&_anchor {
			cursor: pointer;
		}

		&_image {
			width: 10rem;
			min-width: 10rem;
			height: 10rem;
			object-fit: cover;

			img {
				width: 100%;
				height: 100%;
				border-radius: 10rem;
			}

			&.author_card_image_small {
				width: 10rem;
				height: 10rem;
				min-width: 10rem;
			}
		}


		&_content {
			font-family: $F-Montserrat;
			font-size: 2rem;
			line-height: 1.5em;
			text-transform: initial;
			font-weight: $FW-medium;
			line-height: 1.2;
			letter-spacing: 0.05em;
			max-width: 50rem;

			&_name {
				padding-bottom: $G-default/4;
				font-weight: $FW-semibold;
			}

			&_title {
				font-size: 0.8em;
			}

		}
	}

	&_quote {
		margin-top: $G-default/1.5;
		font-weight: $FW-normal;
	}

	&.author_center {

		.author_card {
			text-align: center;
			display: block;

			.author_card_image {
				margin: 0 auto 2rem auto;
			}
		}
	}
}


</style>